const FILE_LABEL_MAX_LENGTH = 30;

/**
 * Builds a short display label from a filename for OTHER attachments.
 * Removes extension, normalizes separators, trims and truncates to max length.
 */
export function buildFileLabelFromFilename(
  filename: string,
  maxLength = FILE_LABEL_MAX_LENGTH
): string {
  if (!filename) return '';

  const withoutPath = filename.split(/[/\\]/).pop() || filename;
  const withoutExt = withoutPath.replace(/\.[^/.]+$/, '');
  const normalized = withoutExt
    .replace(/[_]+/g, ' ')
    .replace(/[-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return normalized.slice(0, maxLength);
}

export const FILE_LABEL_MAX = FILE_LABEL_MAX_LENGTH;
